import * as React from 'react';
import { useState } from 'react';
import AuthLayout from '../../components/AuthLayout';
import { TextInput } from '../../components/fields/TextInput';
import { useRouter } from 'next/router';
import Link from 'next/link';
import sendSignInLinkToEmail from '../../helpers/auth/sendSignInLinkToEmail';

type Props = {};

function Footer() {
  return (
    <p className="text-center text-sm mt-12">
      By pressing continue, you agree to our{' '}
      <span className="text-link">
        <Link href={'/terms-of-service'}>Terms of Service</Link>
      </span>
    </p>
  );
}

export default function SignupPage({}: Props) {
  const [email, setEmail] = useState('');
  const router = useRouter();
  const agentSlug = router.query.agentSlug as string;

  return (
    <AuthLayout
      title={'Sign up'}
      subtitle={'Create an account in 30 seconds'}
      footer={<Footer />}
    >
      <form id={'email-form'}>
        <div className="space-y-6">
          <TextInput
            label="Email address"
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={e => {
              setEmail(e.target.value);
            }}
          />
        </div>
        <button
          type="submit"
          disabled={!email}
          className="btn mt-8 w-full"
          onClick={async e => {
            e.preventDefault();
            await sendSignInLinkToEmail(email, agentSlug);
            router.push({
              pathname: '/auth/check-email',
              query: { email },
            });
          }}
        >
          Continue
        </button>
        <div className="mt-4">
          <p className="text-center">
            Already have an account?{' '}
            <span className="text-link">
              <Link href={'/auth/login'}>Login</Link>
            </span>
          </p>
        </div>
      </form>
    </AuthLayout>
  );
}
